import React, { useEffect, useState } from 'react'
import { Grid, Row, Col, Button, Input, SelectPicker, Form, Panel, Drawer } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
// //import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import ExpertListTable from '../../../components/table/expertListTable/ExpertListTable'
import { searchExpert, searchExpertAI } from '../../../redux/actions/assignExpert'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import ViewButton from '../../../components/buttons/viewButton/ViewButton'
import ExpertListFromAICarousel from '../../../components/table/expertListTable/ExpertListFromAICarousel'

export default function SeachExpertFromAI({
  schema,
  selectedExpert,
  onClickSelect,
  onClickOnline,
  isSubProject,
  countReviewerRequired
}) {
  const { register, handleSubmit, errors, control, reset } = useForm()

  //const [expertData, setExpertData] = useState(schema.itemsList || [])
  const [expertData, setExpertData] = useState([])
  const [totalSize, setTotalSize] = useState(schema.totalSize || schema?.itemsList?.length || 0)
  const [currentSeach, setCurrentSeach] = useState()
  const [suggestionInfo, setSuggestionInfo] = useState()

  const [showDrawer, setShowDrawer] = useState()

  let fontSize = localStorage.getItem('fontSize')
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    handleSearchExpert({ name: '', expert: '', accountType: '', year: '' }, 1, 5)
  }, [])

  const handleSearchExpert = async (data, pagenum, pagesize) => {
    let search = {
      name: data?.name,
      expert: data?.expert,
      accountType: data?.accountType,
      year: data?.year && !isNaN(data?.year) ? parseInt(data?.year, 10) : null,
      TotalQualified: countReviewerRequired || 0
    }

    const searchResult = await searchExpertAI(search, projectId)

    setTotalSize(searchResult?.model?.totalSize)
    setExpertData(searchResult?.model?.itemsList)
    setSuggestionInfo(searchResult?.model?.suggestionInfo)
  }

  const handleChangePage = (pagesize, pagenum) => {
    handleSearchExpert(currentSeach, pagenum, pagesize)
  }

  const onSubmit = (data) => {
    setCurrentSeach(data)
    handleSearchExpert(data, 1, 5)
  }

  const onClickClearValue = () => {
    setExpertData()
    reset({ name: '', expert: '', accountType: '', year: '' })
  }

  return (
    <>
      {expertData.length > 0 &&
      <Panel
        shaded
        header={schema?.headerSummary || 'AI แนะนำผู้ทรงคุณวุฒิ'}
        bordered
        collapsible
        defaultExpanded
      >
        <ExpertListFromAICarousel
          data={expertData}
          selectedExpert={selectedExpert}
          isEditable
          isSubProject={isSubProject}
          onClickSelect={onClickSelect}
          onClickOnline={onClickOnline}
          onReload={handleChangePage}
          totalSize={totalSize}
          suggestionInfo={suggestionInfo}
        />
      </Panel>}
    </>
  )
}
